/* eslint-disable default-case */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import logo from "./cawil_logo.png";

function License() {

  const [licensekey, setLicenseKey] = useState(
    { key: "" }
  );
  const history = useHistory();

  useEffect(() => {

    return () => {
      if (history.action === "POP") {
        // Code here will run when back button fires. Note that it's after the `return` for useEffect's callback; code before the return will fire after the page mounts, code after when it is about to unmount.
        history.push("");
      }
    }
  }, [history, history.action]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setLicenseKey((prevState) => ({
      ...prevState,
      [name]: value
    }));
  }



  const handleSubmit = async () => {

    if (!licensekey.key) {
      alert("All fields required");
    } else {
      switch (licensekey.key) {
        case "cawil-trace-ai": history.push("/login");
      };
    }

  };


  return (
    <div>

      <div className="min-h-screen bg-gray-100 py-6 flex flex-col items-center justify-center sm:py-12">
        <div className="relative py-3 sm:max-w-xl sm:mx-auto">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900 to-light-blue-500 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl"></div>
          <div className="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">
            <div className="max-w-md mx-auto">
              <div>
                <img src={logo} alt="logo" className="h-auto" />
              </div>

              <div class="text-center space-y-2 sm:text-center">
                <div class="space-y-0.5">
                  <p class="text-lg text-black font-normal">
                    Enter license key
                  </p>
                </div>

              </div>

              <input
                type="password"
                placeholder="Enter Key"
                name="key"
                id="key"
                onChange={handleChange}
                className="m-3 flex-1  appearance-none rounded border border-transparent w-full py-2 px-4 bg-gray-200 text-gray-700 placeholder-gray-400 shadow-md rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
              />

              <div className="text-center">
                <button
                  onClick={handleSubmit}
                  type="submit"
                  className="m-3 w-full bg-blue-600 text-white text-base font-normal py-2 px-4 rounded-lg shadow-md hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200"
                >

                  Submit</button>
              </div>


            </div>
          </div>
        </div>
      </div>

    </div>
  );

}
export default License;